
/**
 * トラックマスタページ
 * トラック情報の登録・編集・管理
 */

import React from 'react'
import { useTrucks } from '@/features/masters/hooks/useTrucks'
import TrucksTable from '@/features/masters/components/TrucksTable'
import AddTruckButton from '@/features/masters/components/AddTruckButton'
import { Skeleton } from "@/shared/ui/skeleton"
import { PageLayout } from '@/shared/components'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/shared/ui/breadcrumb'
import { Link } from 'react-router-dom'

/**
 * トラックマスタページコンポーネント
 */
export default function TrucksPage() {
  const { data: trucks, isLoading, error, addTruck, updateTruck, deleteTruck } = useTrucks()

  if (isLoading) {
    return (
      <PageLayout
        title="トラックマスタ"
        description="トラック情報の登録・編集を行います。"
        actions={<Skeleton className="h-10 w-28" />}
      >
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">ホーム</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/masters">マスタ管理</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>トラックマスタ</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <Skeleton className="h-[300px] w-full" />
      </PageLayout>
    )
  }

  if (error) {
    return (
      <PageLayout
        title="トラックマスタ"
        description="トラック情報の登録・編集を行います。"
      >
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">ホーム</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/masters">マスタ管理</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>トラックマスタ</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="text-red-600">
          <p>データの読み込み中にエラーが発生しました: {String(error)}</p>
        </div>
      </PageLayout>
    )
  }

  return (
    <PageLayout
      title="トラックマスタ"
      description="トラック情報の登録・編集を行います。"
      actions={<AddTruckButton onAdd={async (data) => { await addTruck(data); return true; }} />}
    >
      <Breadcrumb className="mb-6">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">ホーム</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/masters">マスタ管理</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>トラックマスタ</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <TrucksTable
        trucks={trucks || []}
        isLoading={isLoading}
        onEdit={async (id, data) => { await updateTruck(id, data); return true; }}
        onDelete={async (id) => { await deleteTruck(id); return true; }}
      />
    </PageLayout>
  )
} 